RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _) {

    'use strict';

    const dimensionConfigurations = [{
        id: 'companyId',
        name: 'Company',
        description: RivalIQ.strings.favorites_builder_companyId_dimension_description,
        props: {
            primaryDimension: 'companyId',
            secondaryDimension: null
        }
    }, {
        id: 'companySetId',
        name: 'Company Set',
        description: RivalIQ.strings.favorites_builder_companySetId_dimension_description,
        props: {
            primaryDimension: 'companySetId',
            secondaryDimension: 'companyId'
        }
    }];

    selectors.Dimension = RivalIQ.views.Select.mixin({
        template: '#dimensionBenchmarkSelectTemplate',

        onChange: function (id) {
            const me = this;

            const dimensionConfiguration = _.find(dimensionConfigurations, {
                id: id
            });

            if (id === 'companySetId') {
                // CompanySet tables don't support private metrics yet, so filter them out. See https://github.com/RivalIQ/rivaliq-server/issues/32408
                let metrics = _.reject(me.dashboardModel.getProp('metrics'), metric => RivalIQ.metric.property.isPrivate(metric));
                if (_.isEmpty(metrics)) {
                    metrics = [{
                        property: 'audience'
                    }];
                }

                me.dashboardModel.setProps({
                    metrics: metrics
                }, {
                    navigate: false,
                    silent: true
                });
            }

            me.dashboardModel.getWidget().setProps(dimensionConfiguration.props, {
                navigate: false
            });

            me.selected = id;
            me.onSelectRendered();
        },

        resetItems: function () {
            const me = this;
            me.setItems(me.getChartOptions());
        },

        isDisabled: function () {
            const me = this;

            const widget = me.dashboardModel.getWidget();
            return widget.widgetId !== RivalIQ.enums.widgetTypes.METRIC_TABLE;
        },

        getChartOptions: function () {
            const hasMultiPrivateChannelAdvanced = RivalIQ.state.plan.get('has_multi_handle_private_advanced');

            return _.map(dimensionConfigurations, dimensionConfiguration => {

                if (!hasMultiPrivateChannelAdvanced && dimensionConfiguration.id === 'companySetId') {
                    dimensionConfiguration = _.defaults({
                        name: 'Company Set (Upgrade to Engage Pro)'
                    }, dimensionConfiguration);
                }

                return dimensionConfiguration;
            });
        },

        onRender: function () {
            const me = this;

            RivalIQ.views.Select.prototype.onRender.apply(me, arguments);

            _.each(dimensionConfigurations, dimensionConfiguration => {
                me.$el.find(`.x-dimension-${dimensionConfiguration.id}`).each((idx, el) => {
                    RivalIQ.utils.tooltip.addPopover($(el), {
                        content: dimensionConfiguration.description
                    });
                });
            });
        },

        onSelectRendered: function () {
            const me = this;

            if (me.selected) {
                const dimensionConfiguration = _.find(dimensionConfigurations, {
                    id: me.selected
                });

                if (dimensionConfiguration) {
                    me.$el.find(`.x-dimension-${dimensionConfiguration.id}`).each((idx, el) => {
                        RivalIQ.utils.tooltip.addPopover($(el), {
                            content: dimensionConfiguration.description
                        });
                    });
                }
            }
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);

            if (me.isDisabled()) {
                me.selected = null;
            } else {
                me.selected = me.dashboardModel.getWidget().getProp('primaryDimension') || 'companyId';
            }
            me.items = me.getChartOptions();
        }
    });
});
